import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit — a 1x1 elevator: a steel cab one storey (2.6 m) tall with two
// brushed-steel sliding door panels split by a thin dark seam, a small call
// panel beside the doors and a thin lintel light strip above. Doors face +Z.
const CAB = "#9aa2a8";
const DOOR = "#b8bfc4";
const SEAM = "#2e2e30";
const BLACK = "#2e2e30";
const LIGHT = "#f2f0e8";

export const elevator = defineModel({
  id: "elevator",
  batchId: "modern",
  name: "Elevator",
  tags: ["modern", "interior", "structure", "elevator", "lift", "transport"],
  summary: "A one-tile steel elevator cab with sliding doors facing +Z.",
  description:
    "A one-tile elevator of the Modern Living kit: a steel cab one storey " +
    "(2.6 m) tall, two brushed-steel sliding door panels with a thin centre " +
    "seam facing +Z, a call panel beside the doors and a lintel light strip " +
    "above the opening.",
  tiles: { w: 1, h: 1 },
  footprint: 1.4,
  parts(): Part[] {
    return [
      // cab shell (front face at z = 0.35)
      { geometry: new THREE.BoxGeometry(1.0, 2.6, 0.85), color: CAB, position: [0, 1.3, -0.075] },
      // front surround: side strips flanking the door opening
      { geometry: new THREE.BoxGeometry(0.1, 2.6, 0.1), color: CAB, position: [-0.45, 1.3, 0.4] },
      { geometry: new THREE.BoxGeometry(0.1, 2.6, 0.1), color: CAB, position: [0.45, 1.3, 0.4] },
      // front header above the door opening (2.2 -> 2.6)
      { geometry: new THREE.BoxGeometry(0.8, 0.4, 0.1), color: CAB, position: [0, 2.4, 0.4] },
      // dark door reveal behind the panels
      { geometry: new THREE.BoxGeometry(0.8, 2.2, 0.04), color: SEAM, position: [0, 1.1, 0.36] },
      // two brushed-steel sliding door panels with a thin seam between
      { geometry: new THREE.BoxGeometry(0.37, 2.1, 0.05), color: DOOR, position: [-0.195, 1.05, 0.4] },
      { geometry: new THREE.BoxGeometry(0.37, 2.1, 0.05), color: DOOR, position: [0.195, 1.05, 0.4] },
      // thin lintel light strip above the doors
      { geometry: new THREE.BoxGeometry(0.7, 0.06, 0.04), color: LIGHT, position: [0, 2.24, 0.44] },
      // call panel beside the doors, with a button
      { geometry: new THREE.BoxGeometry(0.09, 0.24, 0.03), color: BLACK, position: [0.45, 1.1, 0.46] },
      { geometry: new THREE.BoxGeometry(0.04, 0.04, 0.02), color: LIGHT, position: [0.45, 1.13, 0.48] },
    ];
  },
  animations: [],
});
